import React, { useState } from "react";
import Sugar from "sugar";

import ScorecardCollegeInfoPanel from "./ScorecardCollegeInfoPanel";
import ScorecardExpandablePanel from "./ScorecardExpandablePanel";

import ScorecardDetailPanel from "./ScorecardDetailPanel";
import ScorecardDetailStats from "./ScorecardDetailStats";
import ScorecardDetailSparkChart from "./ScorecardDetailSparkChart";

import SocialLinks from "../SocialLinks";

import ClearbitImage from "../ClearbitImage";

import ScorecardCollegeMap from "./ScorecardCollegeMap";

import cx from "classnames";

import Button from "../modules/Button";

// import styles from './styles.scss'

Sugar.extend();

function ScorecardPlaceholder({ navigation, children }) {
  return (
    <section className="scorecard-detail placeholder">
      <div className="scorecard-header">
        <div className="scrim">
          <div className="scorecard-gradient"></div>
        </div>

        <div className="foreground">
          <div className="text">
            <div className="scorecard-nav">
              <div>{navigation}</div>
              <div>{children}</div>
            </div>

            <div className="two-up">
              <div className="logo"></div>

              <div>
                <div className="line"></div>
                <div className="tall wide line"></div>
                <div className="line"></div>
                <div className="line"></div>
                <div className="line"></div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="scorecard-figures">
        <ScorecardDetailPanel
          className="scorecard-income"
          key="income"
          fill="fill-teal"
        >
          <ScorecardDetailStats>
            <ScorecardDetailStats.Title>
              <div className="line"></div>
            </ScorecardDetailStats.Title>

            <ScorecardDetailStats.Value
              value={<div className="tall line"></div>}
            />

            <ScorecardDetailStats.Meta>
              <div className="line"></div>
            </ScorecardDetailStats.Meta>
          </ScorecardDetailStats>
        </ScorecardDetailPanel>

        <ScorecardDetailPanel
          className="scorecard-debt"
          key="debt"
          fill="fill-red"
        >
          <ScorecardDetailStats>
            <ScorecardDetailStats.Title>
              <div className="line"></div>
            </ScorecardDetailStats.Title>

            <ScorecardDetailStats.Value
              value={<div className="tall line"></div>}
            />

            <ScorecardDetailStats.Meta>
              <div className="line"></div>
            </ScorecardDetailStats.Meta>
          </ScorecardDetailStats>
        </ScorecardDetailPanel>

        <ScorecardDetailPanel
          className="scorecard-payment"
          key="payment"
          fill="fill-navy"
        >
          <ScorecardDetailStats>
            <ScorecardDetailStats.Title>
              <div className="line"></div>
            </ScorecardDetailStats.Title>

            <ScorecardDetailStats.Value
              value={<div className="tall line"></div>}
            />

            <ScorecardDetailStats.Meta>
              <div className="line"></div>
            </ScorecardDetailStats.Meta>
          </ScorecardDetailStats>
        </ScorecardDetailPanel>

        <ScorecardDetailPanel
          className="full-width"
          key="compare"
          fill="fill-black"
        >
          <ScorecardDetailStats>
            <ScorecardDetailStats.Title>
              <div className="line"></div>
            </ScorecardDetailStats.Title>

            <ScorecardDetailStats.Meta>
              <div className="line"></div>
            </ScorecardDetailStats.Meta>


            <div className="full line"></div>
            <div className="full line"></div>
            <div className="full line"></div>
            <div className="full line"></div>
            <div className="full line"></div>
            <div className="full line"></div>
          </ScorecardDetailStats>
        </ScorecardDetailPanel>


      </div>
    </section>
  );
}

export default ScorecardPlaceholder;
